import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware, replace } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const CASHIN_SCANNED = keyMirror({
  INIT_REQUEST: null,
  INIT_SUCCESS: null,
  CANCEL_REQUEST: null,
  CANCEL_SUCCESS: null,
}, 'CASHIN_SCANNED')

// ------------------------------------
// Actions
// ------------------------------------
export function init(globalId) {
  return (dispatch, getState) => {
    const state = getState()
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: '/jollychic-service/cashin/order',
        method: 'POST',
        body: {
          globalId: globalId,
          accessToken: sessionStorage.getItem('accessToken')
        },
        requestAction: CASHIN_SCANNED.INIT_REQUEST,
        successAction: CASHIN_SCANNED.INIT_SUCCESS,
        success: function(result) {
          if (state.router.location.pathname !== '/cashIn/scanned') {
            return false
          }
          if (result.status === 'LOADING') {
            return setTimeout(() => {
              dispatch(init(globalId))
            }, 2000)
          }
          return dispatch(replace(`/cashIn/confirm?globalId=${globalId}`))
        }
      })
    )
  }
}

export function cancel(globalId) {
  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        endpoint: '/jollychic-service/cashin/cancel',
        method: 'POST',
        body: {
          globalId: globalId,
          accessToken: sessionStorage.getItem('accessToken')
        },
        requestAction: CASHIN_SCANNED.CANCEL_REQUEST,
        successAction: CASHIN_SCANNED.CANCEL_SUCCESS,
        success: function(result) {
          dispatch(replace(`/cashIn/result?globalId=${globalId}`))
        }
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CASHIN_SCANNED.INIT_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [CASHIN_SCANNED.INIT_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
  [CASHIN_SCANNED.CANCEL_REQUEST]: (state, action) => Object.assign({}, state, action.payload),
  [CASHIN_SCANNED.CANCEL_SUCCESS]: (state, action) => Object.assign({}, state, action.payload),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'cashInScanned',
    reducerMap: {
      cashInScannedState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
